import { defineMessages } from "react-intl";

export const messages = defineMessages({
  discountVariantsHeader: {
    id: "lehGc9",
    defaultMessage: "Eligible Variants",
    description: "section header",
  },
  discountVariantsButton: {
    id: "ySqrUU",
    defaultMessage: "Assign variants",
    description: "button",
  },
  discountVariantsTableProductHeader: {
    id: "6cMkfT",
    defaultMessage: "Product Name",
    description: "table head",
  },
  discountVariantsTableVariantHeader: {
    id: "lHccsy",
    defaultMessage: "Variant Name",
    description: "table head",
  },
  discountVariantsTableTypeHeader: {
    id: "Q1HhPk",
    defaultMessage: "Product Type",
    description: "table head",
  },
  discountVariantsNotFound: {
    id: "/oyr6M",
    defaultMessage: "No variants found",
    description: "no variants",
  },
});
